// extracted by mini-css-extract-plugin
export var alt = "MembershipBenefits-module--alt--ad35f";
export var benfitsSubTitle = "MembershipBenefits-module--benfitsSubTitle--4aeb9";
export var benfitsTitle = "MembershipBenefits-module--benfitsTitle--ad011";
export var container = "MembershipBenefits-module--container--38a19";
export var description = "MembershipBenefits-module--description--9d28a";
export var desktopOnly = "MembershipBenefits-module--desktopOnly--0c1e2";
export var main = "MembershipBenefits-module--main--42738";
export var mobileOnly = "MembershipBenefits-module--mobileOnly--ab8e0";
export var textLeft = "MembershipBenefits-module--textLeft--2c8da";
export var visuallyHidden = "MembershipBenefits-module--visuallyHidden--906f3";